import React, {Component} from 'react';
import {connector} from '../store';
import {Link} from 'react-router-dom';
import CoveImage from "./CoveImage.jsx";
import ButtonPlay from "./ButtonPlay.jsx";
import {getBasicVideoTrackingLabel, videoDataToPlayerData} from '../helpers';

import ga from '../../../vendor/google-analytics';

class VideoEndScreen extends Component {
  trackingCategory: string;

  state: {
    timerID: ?number;
  };

  constructor(props: *) {
    super(props);

    this.state = {
      timerID: null
    };

    this.trackingCategory = 'VideoPlayer | Endscreen';
  }

  componentWillReceiveProps(nextProps: *) {
    if (nextProps.player.endScreen.autoplayCancelled && this.state.timerID !== null) {
      clearInterval(this.state.timerID);
    }
  }

  componentDidMount() {
    this.setState({timerID:setInterval( function() {
      this.props.autoplayTimerTick(this.props.history)
    }.bind(this), 1000)});

    if (this.getLabel()) {
      ga('send', 'event', this.trackingCategory, 'Displayed | [P]', this.getLabel());
    }
  }

  componentWillUnmount() {
    if (this.state.timerID !== null) {
      clearInterval(this.state.timerID);
    }
  }

  getLabel() {
    let label = '';

    // Only compute a label if there is a video to compute against
    if (this.props.video) {

      // Get the base tracking label
      let baseLabel = getBasicVideoTrackingLabel(this.props.show, this.props.player);

      if (baseLabel) {

        // Add in the next video data
        label = [baseLabel, this.props.video.title, this.props.video.tpMediaId].join(' | ');
      }
    }

    return label;
  }

  render() {
    let videoUrl = `/${this.props.show.slug}/video/${this.props.video.slug}/`;
    let manualPlayHandler = () => {
      if (this.getLabel()) {
        ga('send', 'event', this.trackingCategory, 'Click To Play | [A]', this.getLabel(), this.props.player.endScreen.autoplayTimer.timeLeft);
      }

      this.props.loadPlayerData(videoDataToPlayerData(this.props.video, true));
    };

    return (
      <div className="video-player-share-overlay">
        <div className="share-overlay-wrapper inner-page-content row">
          <div className="show-for-xxlarge-up xxlarge-3  columns">
            &nbsp;
          </div>
          <div className="share-content small-12 xxlarge-6  columns">
            <div className="share-overlay-up-next">
              <span className="up-next-label headline-section">Up Next</span>
              {!this.props.player.endScreen.autoplayCancelled &&
                <span className="up-next-timer">
                  Playing in <span className="up-next-countdown">{this.props.player.endScreen.autoplayTimer.timeLeft}</span> ...
                </span>
              }
              <br/>

              <Link to={videoUrl} className="up-next-mobile-title headline-section" onClick={manualPlayHandler}>
                {this.props.video.title}
              </Link>
            </div>
            <div className="related-items-row">
              <div className="related-item video-item">
                <Link to={videoUrl} className="video-item-watchable no-delay" onClick={manualPlayHandler}>
                  <div className="related-item-preview video-item-preview">
                    <CoveImage
                      alt={this.props.video.title}
                      aspectRatio={0.5625}
                      class="related-item-thumbnail video-item-thumbnail"
                      imageSizes={{min: 100, max: 400, step: 100}}
                      sizes={[{breakpoint: '1201px', width: '400px'}, {breakpoint: '769px', width: '33vw'},
                        {breakpoint: '641px', width: '50vw'}, {breakpoint: '0', width: '100vw'}]}
                      url={this.props.video.mezzanine}/>
                    <ButtonPlay animate={!this.props.player.endScreen.autoplayCancelled} />
                  </div>
                  <div className="related-item-title video-item-title headline-section">
                    {this.props.video.title}
                  </div>
                  <div className="related-item-description video-item-description">
                    {this.props.video.extendedDescription}
                  </div>
                </Link>
              </div>
            </div>
          </div>
          <div className="show-for-xxlarge-up xxlarge-3 columns">
            &nbsp;
          </div>
          <div className="small-12 columns autoplay-cancel-wrapper">
            {!this.props.player.endScreen.autoplayCancelled ?
              <a href="#" className="no-delay autoplay-cancel" onClick={(e) => {
                e.preventDefault();

                if (this.getLabel()) {
                  ga('send', 'event', this.trackingCategory, 'Autoplay Cancelled | [P]', this.getLabel(), this.props.player.endScreen.autoplayTimer.timeLeft);
                }

                this.props.autoplayCancel();
              }}>Cancel</a> :
              <a href="" className="no-delay autoplay-cancel" onClick={(e) => {
                e.preventDefault();

                if (this.getLabel()) {
                  ga('send', 'event', this.trackingCategory, 'Return To Video | [A]', this.getLabel());
                }

                this.props.returnToVideo();
              }}>Return to Video</a>
            }
            &nbsp;
          </div>
        </div>
      </div>
    );
  }
}

export default connector(VideoEndScreen);